// Normalisation de blanks[] pour text_holes (miroir backend).

const normKey = (s) => String(s ?? '').replace(/\s+/g, ' ').trim().toLowerCase();

function normalizeBlank(b) {
  const answer = String(b?.answer ?? '').trim();
  const seen = new Set(answer ? [normKey(answer)] : []);
  const distractors = [];
  for (const d of Array.isArray(b?.distractors) ? b.distractors : []) {
    const s = String(d ?? '').trim();
    const k = normKey(s);
    if (!s || !k || seen.has(k)) continue;
    seen.add(k);
    distractors.push(s);
  }
  const out = { answer, distractors };
  if (b?.type) out.type = b.type;
  if (b?.hint) out.hint = b.hint;
  return out;
}

/** Normalise `content.blanks[]` (schéma canonique uniquement). */
export function toBlanks(content) {
  if (!content || typeof content !== 'object') return [];
  if (!Array.isArray(content.blanks)) return [];
  return content.blanks.map(normalizeBlank).filter((b) => b.answer);
}

export function bankFromBlanks(blanks) {
  const seen = new Set();
  const bank = [];
  for (const b of Array.isArray(blanks) ? blanks : []) {
    for (const w of [b.answer, ...(b.distractors || [])]) {
      const k = normKey(w);
      if (!w || !k || seen.has(k)) continue;
      seen.add(k);
      bank.push(w);
    }
  }
  return bank;
}

export function answersOf(blanks) {
  return (Array.isArray(blanks) ? blanks : []).map((b) => b.answer).filter(Boolean);
}

export function canonicalTextHolesContent(base, partial = {}) {
  return { ...(base && typeof base === 'object' ? base : {}), ...partial };
}
